// Loads Razorpay's Checkout.js on demand and opens the payment modal.
// No npm package needed — this is the standard script-tag integration.

let scriptPromise = null;

export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => {
      scriptPromise = null;
      reject(new Error("Unable to load the payment gateway. Please check your connection and try again."));
    };
    document.body.appendChild(script);
  });
  return scriptPromise;
}

/**
 * Opens the Razorpay checkout modal.
 * @param {object} opts
 * @param {string} opts.keyId
 * @param {number} opts.amount - amount in paise
 * @param {string} opts.currency
 * @param {string} opts.orderId - Razorpay order id
 * @param {string} opts.name - display name (e.g. cafe name)
 * @param {string} [opts.description]
 * @param {string} [opts.contact] - customer phone number
 * @param {(response: {razorpay_payment_id: string, razorpay_order_id: string}) => void} opts.onSuccess
 * @param {() => void} [opts.onDismiss] - called when the user closes the modal without paying
 */
export async function openRazorpayCheckout(opts) {
  await loadRazorpayScript();

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: opts.keyId,
      amount: opts.amount,
      currency: opts.currency || "INR",
      order_id: opts.orderId,
      name: opts.name || "Blue Tokai Coffee Roasters",
      description: opts.description || "Cafe order",
      prefill: opts.contact ? { contact: opts.contact } : undefined,
      theme: { color: "#1c1c1c" },
      handler: (response) => {
        opts.onSuccess?.(response);
        resolve(response);
      },
      modal: {
        ondismiss: () => {
          opts.onDismiss?.();
          reject(new Error("dismissed"));
        },
      },
    });
    rzp.on("payment.failed", (response) => {
      reject(new Error(response?.error?.description || "Payment failed. Please try again."));
    });
    rzp.open();
  });
}
